<script setup lang="ts">
import { RouteName } from 'hybridly';
import { RouterLink } from 'hybridly/vue';

const props = defineProps<{
  title: string | number;
  value: string | number;
  routeName: RouteName;
}>();
const { matches } = useRoute();
const { properties } = useDialog();

const isActive = computed(() => {
  return matches(props.routeName) || properties.value?.baseUrl === props.routeName;
});
</script>

<template>
  <component
    :is="isActive ? 'div' : RouterLink"
    :href="isActive ? null : route(routeName)"
    :class="isActive ? 'border-current bg-secondary-950' : 'border-secondary-900 bg-secondary-900'"
    class="group relative inline-flex w-1/2 flex-1 flex-col items-center justify-center gap-1.5 border-b-2 pb-3 pl-4 pr-2 pt-3.5 text-white"
  >
    <div
      v-if="!isActive"
      class="absolute inset-0 z-0 transition group-hover:bg-secondary-950/30 group-active:bg-secondary-900/70"
    ></div>
    <div class="relative z-10 inline-flex items-start justify-between self-stretch">
      <div class="flex flex-1 items-start justify-start gap-1">
        <div class="justify-start text-3xl font-medium leading-normal text-white">
          {{ value ?? 0 }}
        </div>
      </div>
    </div>
    <div class="relative z-10 inline-flex h-4 items-center justify-start gap-2 self-stretch pl-px">
      <div class="flex-1 justify-start text-sm font-medium leading-none text-white">
        {{ title }}
      </div>
    </div>
  </component>
</template>
